import { useLayoutEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { getUser, loginByToken } from 'data/actions/user';
import { userDataSelector } from 'data/selectors/user';

import { useGetUser } from './useGetUser';

export const TOKEN_QUERY_PARAM_NAME = 'token';

export const useLoginByTokenQueryParam = () => {
  const dispatch = useDispatch();
  const user = useSelector(userDataSelector);
  const { getUser: initUser } = useGetUser({ ignoreAuthToken: true });

  useLayoutEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const authTokenString = searchParams.get(TOKEN_QUERY_PARAM_NAME);

    if (!authTokenString || user?.email) {
      return;
    }

    dispatch(
      loginByToken(
        authTokenString,
        () => {
          dispatch(getUser({}));
        },
        initUser
      )
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, user?.email]);
};
